export default "__VITE_ASSET__D7hJ48ju__"